import React, { createContext, useContext, useState, useEffect } from 'react';

// JSON 파일들을 동적으로 import
const loadTranslations = async (language) => {
    try {
        const translations = await import(`../locales/${language}.json`);
        return translations.default;
    } catch (error) {
        console.error(`Failed to load translations for ${language}:`, error);
        // 기본값으로 한국어 로드
        const fallback = await import('../locales/ko.json');
        return fallback.default;
    }
};

    const LanguageContext = createContext();

    export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
    };

    export const LanguageProvider = ({ children }) => {
    const [currentLanguage, setCurrentLanguage] = useState('ko');
    const [translations, setTranslations] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isInitialized, setIsInitialized] = useState(false);

    // 언어 변경 함수
    const changeLanguage = async (language) => {
        setIsLoading(true);
        try {
        const newTranslations = await loadTranslations(language);
        setTranslations(newTranslations);
        setCurrentLanguage(language);
        
        // localStorage에 선택한 언어 저장
        localStorage.setItem('selectedLanguage', language);
        
        } catch (error) {
        console.error('Failed to change language:', error);
        } finally {
        setIsLoading(false);
        setIsInitialized(true);
        }
    };

    // 번역 함수 - 중첩된 키 지원 (예: "header.login")
    const t = (key, defaultValue = '') => {
        if (!isInitialized || !translations || Object.keys(translations).length === 0) {
        return defaultValue;
        }

        const keys = key.split('.');
        let value = translations;
        
        for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
            value = value[k];
        } else {
            return defaultValue || key;
        }
        }
        
        // return typeof value === 'string' ? value : (defaultValue || key);

        return value ?? (defaultValue || key);  // t 함수의 반환을 string 뿐만 아니라 object도 가능하게 수정
    };

    // 컴포넌트 마운트 시 저장된 언어 로드
    useEffect(() => {
        const initializeLanguage = async () => {
        const savedLanguage = localStorage.getItem('selectedLanguage') || 'ko';
        await changeLanguage(savedLanguage);
        };
        
        initializeLanguage();
    }, []);

    const value = {
        currentLanguage,
        changeLanguage,
        t,
        isLoading,
        isInitialized,
        availableLanguages: ['ko', 'en']
    };

    return (
        <LanguageContext.Provider value={value}>
        {children}
        </LanguageContext.Provider>
    );
};